<template>
  <div class="dipers-option">
    <div class="warning info">
      <p>{{ warningText }}</p>
    </div>
    <b-field label="Informe com detalhes qual a finalidade e onde necessita apresentar o atestado">
      <b-input type="textarea" v-model="diapersInput" />
    </b-field>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  name: 'DiapersOptions',
  data () {
    return {
      warningText: 'O atestado para fornecimento de fraldas descartáveis destina-se a pacientes adultos ou crianças, portadores de doenças crônicas neurológicas, que apresentam incontinência e, portanto, fazem uso contínuo de fraldas.'
    }
  },
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  computed: {
    diapersInput: {
      get () {
        return this.value
      },
      set (newVal) {
        this.$emit('input', newVal)
      }
    }
  },
  updated () {
    this.handleData()
  },
  methods: {
    ...mapMutations([
      'DESABILITAR_BOTAO_ENVIAR'
    ]),
    handleData () {
      this.value ? this.DESABILITAR_BOTAO_ENVIAR(false) : this.DESABILITAR_BOTAO_ENVIAR(true)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/stylesheets/base";
@import "~@/assets/stylesheets/forms";
@import "~@/assets/stylesheets/warnings";
.dipers-option{
  margin-top: 2rem;
  .textarea{
    resize: none;
  }
  .block{
    margin-top: 2rem;
    max-width: 80%;
    padding-bottom: 2.5rem;
  }
  .warning {
    max-width: 80%;
    margin-bottom: 2rem;
  }
  .warning p:before{
    top: 0.31rem;
  }
}
@media (max-width: $mobile-width-breakpoint) {
  .block{
    max-width: 100%;
  }
  .warning {
    max-width: 100%;
  }
}
</style>
